import sendToServer from './send-to-server';
import trackEvent from './track-event';

const OpportunityTracking = {
  init() {
    if (!($('.opportunities').length > 0)) return;
    $('.opportunity-link').click(this.handleOpportunityClick.bind(this));
    $('.interested').click(this.handleInterestedClick.bind(this));
  },

  handleInterestedClick(event) {
    $('.interested-section').fadeOut();
    trackEvent('Careers', 'registered interest', $('.header h2').html());
    sendToServer('/api/v2/career_relationships/' + $('.opportunities').data('career-id'),
                 { interested: true },
                 this.brieflyShowInterestConfirmation,
                 "PATCH");
  },

  handleOpportunityClick(event) {
    let $link = $(event.target).closest('.opportunity-link');
    let $opportunity = $link.find('.opportunity');

    sendToServer('/api/v2/events/',
                 { event: 'viewed_opportunity',
                   career_id: $opportunity.data('career-id'),
                   value: $opportunity.data('opportunity-id')});
  },

  brieflyShowInterestConfirmation() {
    window.setTimeout(()=>{ $('.interest-success-message').fadeOut() }, 3000)
    $('.interest-success-message').fadeIn();
  }
};

$(document).ready(()=> {
  OpportunityTracking.init();
});
